<template>
  <div class="app-container">
    <a-form laba-width="110px" class="UniformCss">
      <a-row :gutter="10">
        <a-col v-if="type === 2" :span="4">
          <a-form-item label="订单编号">
            <a-input v-model="data.applyOrderCode" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col v-if="type === 2" :span="4">
          <a-form-item label="申领部门">
            <a-input v-model="data.orgName" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col v-if="type === 2" :span="4">
          <a-form-item label="申领人">
            <a-input v-model="data.drawMan" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="物料号">
            <a-input v-model="data.materialCode" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="物料名称">
            <a-input v-model="data.materialName" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="物料类型">
            <a-select v-model="data.materialType" clearable>
              <a-select-option v-for="item in list.PromotionMaterialType" :key="item.code" :value="item.code" >{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6">
          <a-form-item label="所属仓库">
            <a-select v-model="data.warehouse" clearable>
              <a-select-option v-for="item in list.PromotionStockType" :key="item.code" :value="item.code" >{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <a-col v-if="type != 0 && type != 1 && type != 2" :span="4">
          <a-form-item label="单位">
            <a-input v-model="data.unit" clearable placeholder="请输入" />
          </a-form-item>
        </a-col>
        <!-- <a-col v-if="type === 0" :span="6">
          <a-form-item label="新增时间">
            <a-date-picker v-model="data.begindateStart"  valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期" @change="data.enddateEnd ? (data.begindateEnd = '') : ''" />
          </a-form-item>
        </a-col> -->
        <a-col v-if="type === 1" :span="4">
          <a-form-item label="入库时间">
            <a-date-picker v-model="data.begindateStart"  valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期" @change="data.enddateEnd ? (data.begindateEnd = '') : ''" />
          </a-form-item>
        </a-col>
        <a-col v-if="type === 2" :span="4">
          <a-form-item label="出库时间">
            <a-date-picker v-model="data.begindateStart"  valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期" @change="data.enddateEnd ? (data.begindateEnd = '') : ''" />
          </a-form-item>
        </a-col>
        <a-col v-if="type === 1 || type === 2" :span="4">
          <a-form-item label="至">
            <a-date-picker v-model="data.begindateEnd"  valueFormat="YYYY-MM-DD" type="date" placeholder="选择日期" :picker-options="{ disabledDate: time => time.getTime() < new Date(data.begindateStart) - 8.64e7 }" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'SiftMaterial',
  // eslint-disable-next-line vue/require-prop-types
  props: ['data', 'type', 'list'],
  data() {
    return {}
  },
  computed: {},
  created() {
  },
  beforeMount() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
</style>
